import {
  RECEIVE_USER_ME,
  REQUEST_USER_ME,
  FAILED_USER_ME,
  REQUEST_LOGIN,
  RECEIVE_LOGIN,
  FAILED_LOGIN,
  RESET_LOGIN,
  REQUEST_LOGOUT,
  RECEIVE_LOGOUT
} from './userActions';

const initialState = {
  isFetching: false,
  isLoaded: false,
  isLoggingIn: false,
  data: undefined,
  users: {},
  token: undefined
};

export default function userReducer(state = initialState, action) {
  switch (action.type) {
    case REQUEST_USER_ME:
      return Object.assign({}, state, { isFetching: true });

    case RECEIVE_USER_ME:
      return Object.assign({}, state, { isFetching: false, isLoaded: true, data: action.data });

    case FAILED_USER_ME:
      return Object.assign({}, state, { isFetching: false, isLoaded: true });

    case REQUEST_LOGIN:
      return Object.assign({}, state, { isLoggingIn: true });

    case RECEIVE_LOGIN:
      return Object.assign({}, state, { isLoggingIn: false, token: action.tokenId });

    case FAILED_LOGIN:
      return Object.assign({}, state, { isLoggingIn: false, loginFailReason: action.reason });

    case RESET_LOGIN:
      return Object.assign({}, state, { isLoggingIn: false, loginFailReason: undefined });

    case REQUEST_LOGOUT:
      const logginOutState = {
        isLoaded: false,
        isLoggingIn: false,
        loginFailReason: undefined,
        users: [],
        token: undefined,
        data: undefined
      };
      return Object.assign({}, state, logginOutState);

    case RECEIVE_LOGOUT:
      const loggedOutState = {
        isLoaded: true,
        loginFailReason: undefined,
        users: [],
        token: undefined,
        data: undefined
      };
      return Object.assign({}, state, loggedOutState);

    default:
      return state;
  }
}
